import {safeDefine} from '@breuni-ui/safe-define';
import {Carousel} from '@breuni-ui/carousel';
import {CSSResultGroup, unsafeCSS} from 'lit';
import styles from './carousel.scss';

export default class EntsCarousel extends Carousel {
  static get styles(): CSSResultGroup {
    return [super.styles, unsafeCSS(styles)].filter(style => style !== undefined);
  }
}

safeDefine('ents-carousel', EntsCarousel);
